module.exports = __webpack_public_path__ + "img/1.0067d7a5.jpg";